"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FiltersV3Controller", {
    enumerable: true,
    get: function() {
        return FiltersV3Controller;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
const _filtersv3service = require("~/services/v3/filters-v3.service");
const _controllers = require("~/constants/controllers");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let FiltersV3Controller = class FiltersV3Controller {
    async filterList(context, viewId, hookId) {
        return {
            list: await this.filtersV3Service.filterList(context, {
                viewId,
                hookId
            })
        };
    }
    async filterCreate(context, viewId, linkColumnId, hookId, body, req) {
        const filter = await this.filtersV3Service.filterCreate(context, {
            filter: body,
            viewId: viewId,
            user: req.user,
            req
        });
        return filter;
    }
    async filterUpdate(context, body, req, viewId) {
        const filter = await this.filtersV3Service.filterUpdate(context, {
            filterId: body.id,
            filter: body,
            user: req.user,
            viewId,
            req
        });
        return filter;
    }
    async filterReplace(context, body, req, viewId) {
        const filter = await this.filtersV3Service.filterReplace(context, {
            filter: body,
            user: req.user,
            req,
            viewId
        });
        return filter;
    }
    async filterDelete(context, viewId, body, req) {
        const filter = await this.filtersV3Service.filterDelete(context, {
            req,
            viewId,
            filterId: body.id
        });
        return filter;
    }
    constructor(filtersV3Service){
        this.filtersV3Service = filtersV3Service;
    }
};
_ts_decorate([
    (0, _common.Get)([
        `${_controllers.PREFIX_APIV3_METABASE}/tables/:tableId/views/:viewId/filters`,
        `${_controllers.PREFIX_APIV3_METABASE}/views/:viewId/filters`
    ]),
    (0, _extractidsmiddleware.Acl)('filterList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_param(2, (0, _common.Param)('hookId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], FiltersV3Controller.prototype, "filterList", null);
_ts_decorate([
    (0, _common.Post)([
        `${_controllers.PREFIX_APIV3_METABASE}/tables/:tableId/views/:viewId/filters`,
        `${_controllers.PREFIX_APIV3_METABASE}/views/:viewId/filters`,
        `${_controllers.PREFIX_APIV3_METABASE}/hooks/:hookId/filters`,
        `${_controllers.PREFIX_APIV3_METABASE}/links/:linkColumnId/filters`
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('filterCreate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_param(2, (0, _common.Param)('linkColumnId')),
    _ts_param(3, (0, _common.Param)('hookId')),
    _ts_param(4, (0, _common.Body)()),
    _ts_param(5, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        String,
        String,
        typeof _nocodbsdk.FilterCreateV3Type === "undefined" ? Object : _nocodbsdk.FilterCreateV3Type,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], FiltersV3Controller.prototype, "filterCreate", null);
_ts_decorate([
    (0, _common.Patch)([
        `${_controllers.PREFIX_APIV3_METABASE}/tables/:tableId/views/:viewId/filters`,
        `${_controllers.PREFIX_APIV3_METABASE}/views/:viewId/filters`
    ]),
    (0, _extractidsmiddleware.Acl)('filterUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Body)()),
    _ts_param(2, (0, _common.Req)()),
    _ts_param(3, (0, _common.Param)('viewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _nocodbsdk.FilterUpdateV3Type === "undefined" ? Object : _nocodbsdk.FilterUpdateV3Type,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], FiltersV3Controller.prototype, "filterUpdate", null);
_ts_decorate([
    (0, _common.Put)([
        `${_controllers.PREFIX_APIV3_METABASE}/tables/:tableId/views/:viewId/filters`,
        `${_controllers.PREFIX_APIV3_METABASE}/views/:viewId/filters`
    ]),
    (0, _extractidsmiddleware.Acl)('filterUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Body)()),
    _ts_param(2, (0, _common.Req)()),
    _ts_param(3, (0, _common.Param)('viewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _nocodbsdk.FilterCreateV3Type === "undefined" ? Object : _nocodbsdk.FilterCreateV3Type,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], FiltersV3Controller.prototype, "filterReplace", null);
_ts_decorate([
    (0, _common.Delete)([
        `${_controllers.PREFIX_APIV3_METABASE}/tables/:tableId/views/:viewId/filters`,
        `${_controllers.PREFIX_APIV3_METABASE}/views/:viewId/filters`
    ]),
    (0, _extractidsmiddleware.Acl)('filterDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        Object,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], FiltersV3Controller.prototype, "filterDelete", null);
FiltersV3Controller = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _filtersv3service.FiltersV3Service === "undefined" ? Object : _filtersv3service.FiltersV3Service
    ])
], FiltersV3Controller);
